import {Card, Col, Row, Button} from "react-bootstrap";
import React from "react";
import {FaFacebookSquare} from "react-icons/fa";
import {FaRegCalendarAlt} from "react-icons/fa";
import {GoBrowser} from "react-icons/go";
import {FaYoutube} from "react-icons/fa";
import {FiMail} from "react-icons/fi";

const Contact = () => {
    return (
            <Row className="mt-4 mb-4">
                <Col>
                    <Card>
                        <Card.Header>
                            <h4><b>ช่องทางติดต่อ</b></h4>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col>
                                    <Card.Title>อาคารศูนย์สารสนเทศ มหาวิทยาลัยขอนแก่น ชั้น 6</Card.Title>
                                    <Card.Text>
                                        เลขที่ 123 มหาวิทยาลัยขอนแก่น ถ.มิตรภาพ ต.ในเมือง อ.เมือง จ.ขอนแก่น รหัสไปรษณีย์
                                        40002
                                    </Card.Text>
                                    {/*<Card.Text>*/}
                                    {/*    <div><b>หมายเลขโทรศัพท์</b></div>*/}
                                    {/*    <div>42514-17</div>*/}
                                    {/*</Card.Text>*/}
                                    <Card.Text>
                                        <div><b>Email</b></div>
                                        <div>ltic.psli@kku.ac.th</div>
                                    </Card.Text>

                                    {/*<Card.Text>*/}
                                    {/*    <Button className="mr-3 mt-2" variant="outline-info" href="https://ltic.kku.ac.th/home" target="_blank">LTIC Website</Button>*/}
                                    {/*    <Button className="mr-3 mt-2" variant="outline-info" href="https://ltic.kku.ac.th/booking" target="_blank">LTIC Booking</Button>*/}
                                    {/*    <Button className="mr-3 mt-2" variant="outline-info" href="https://www.facebook.com/LTICKKU" target="_blank">Facebook</Button>*/}
                                    {/*</Card.Text>*/}

                                    <Card.Text>
                                        <div><b>Social Media</b></div>
                                        <div className="mt-1">
                                            <a href="https://ltic.kku.ac.th" target="_blank" style={{color:"black"}}>
                                                <GoBrowser size={20} className="mb-1"/> Website</a>
                                        </div>
                                        <div className="mt-2">
                                            <a href="https://www.facebook.com/LTICKKU" target="_blank" style={{color:"black"}}>
                                                <FaFacebookSquare size={20} className="mb-1"/> Facebook</a>
                                        </div>
                                        <div className="mt-2">
                                            <a href="https://www.youtube.com/channel/UCmMusmK6oIlLCsLB22NLePA"
                                               target="_blank" style={{color:"black"}}>
                                                <FaYoutube size={20} className="mb-2"/> Youtube</a>
                                        </div>
                                        <div className="mt-2">
                                            <a href="https://ltic.kku.ac.th/booking" target="_blank" style={{color:"black"}}>
                                                <FaRegCalendarAlt size={20} className="mb-2"/> LTIC Booking</a>
                                        </div>
                                    </Card.Text>
                                </Col>

                                <Col>
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3825.9787443119385!2d102.82154891445562!3d16.47661393276869!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31228a8dcedb7fbf%3A0xf70d2c62e60e7e33!2z4Lit4Liy4LiE4Liy4Lij4Lio4Li54LiZ4Lii4LmM4Liq4Liy4Lij4Liq4LiZ4LmA4LiX4LioIOC4oeC4q-C4suC4p-C4tOC4l-C4ouC4suC4peC4seC4ouC4guC4reC4meC5geC4geC5iOC4mQ!5e0!3m2!1sth!2sth!4v1633958802984!5m2!1sth!2sth"
                                        width="100%" height="400px" style={{border: 0}} allowFullScreen=""
                                        loading="lazy">
                                    </iframe>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
    )
}
export default Contact;